var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 2.8999C8.44185 2.8999 8.80002 3.25807 8.80002 3.6999V7.6999H12.8C13.2419 7.6999 13.6 8.05807 13.6 8.4999C13.6 8.94173 13.2419 9.2999 12.8 9.2999H8.80002V13.2999C8.80002 13.7417 8.44185 14.0999 8.00002 14.0999C7.5582 14.0999 7.20002 13.7417 7.20002 13.2999V9.2999H3.20002C2.7582 9.2999 2.40002 8.94173 2.40002 8.4999C2.40002 8.05807 2.7582 7.6999 3.20002 7.6999H7.20002V3.6999C7.20002 3.25807 7.5582 2.8999 8.00002 2.8999Z",
    fill: "#c5c5c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPlus);
export default __webpack_public_path__ + "static/media/greyPlus.e6591566464c94c8158c55f9c429e9cd.svg";
export { ForwardRef as ReactComponent };